import { spaceAPI } from '@/api';
import CommonSpaceListContainer from '@/components/common/CommonSpaceListContainer';
import AvnfrGGHeader from './AvnfrGGHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface AvnfrGGSpaceDataType {
  id: number;
  publish: boolean;
  type: string;
  floor: number;
  title: string;
  category: string;
  description: string;
  phone: string;
  time: string;
  link: string;
  updatedAt: string;
}

  const columnHelper = createColumnHelper<AvnfrGGSpaceDataType>();

const categoryMap: { [key: string]: string } = {
  '21': 'Dining',
  '22': 'Café&Dessert',
  '23': 'Fashion&Beauty',
  '24': 'Retail&Service',
};

const typeMap: { [key: string]: string } = {
  atti: '아띠존',
  raon: '라온존',
  };

const getColumns = (): ColumnDef<AvnfrGGSpaceDataType, any>[] => {
    const baseColumns = [
      columnHelper.accessor('id', {
        header: 'ID',
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor('title', {
        header: '이름',
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor('description', {
        header: '설명',
        cell: (info) => {
          const text = info.getValue() || '';
          return text.length > 10 ? `${text.slice(0, 10)}...` : text;
        },
      }),
      columnHelper.accessor('category', {
        header: '카테고리',
      cell: (info) => categoryMap[info.getValue()] || info.getValue(),
      }),
      columnHelper.accessor('type', {
        header: 'zone',
      cell: (info) => typeMap[info.getValue()] || info.getValue(),
      }),
      columnHelper.accessor('floor', {
        header: '층',
        cell: (info) => {
          const floor = info.getValue().toString();
          return floor === '-1' ? 'B1' : floor;
        },
      }),
      columnHelper.accessor('publish', {
        header: '앱 사용 여부',
        cell: (info) => (info.getValue() ? '사용' : '미사용'),
      }),
      columnHelper.accessor('updatedAt', {
        header: '수정일',
        cell: (info) => new Date(info.getValue()).toLocaleDateString(),
      }),
    ];

  return baseColumns.filter(Boolean) as ColumnDef<AvnfrGGSpaceDataType, any>[];
};

const AvnfrGGContainer = () => {
  return (
    <CommonSpaceListContainer<AvnfrGGSpaceDataType>
      HeaderComponent={AvnfrGGHeader}
      queryKey="getSpacesAvnfrgg"
      queryFn={() =>
        spaceAPI.getSpacesAvnfrGG({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
      baseRoute="/avnfr-gg/space"
      buttonColor="avnfr"
      showCreateButton={false}
    />
  );
};

export default AvnfrGGContainer;
